<bootstrap-popup [id]="id" [title]="'Ajouter un lien à votre plan de prévention'" [displaySubject]="displaySubject" [modalSize]="'modal-lg'" [windowCloseButton]="true">
	<pannel [title]="'Lien du PDP'" [expandable]="true">
		<form role="form" class="form-horizontal">
			<div class="form-group row col-sm-12">
				<div class="col-sm-3">
					<label for="lien" class="control-label">URL: </label>
				</div>
				<div class="col-sm-9">
					<input id="lien" name="lien" class="form-control" placeholder="Lien du PDP" maxLength="1024" [(ngModel)]="link" />
				</div>
			</div>
	 		<div class="row">
				<div class="col-md-12">
					<div class="form-group text-center">
						<button type="button" class="btn btn-success" style="margin-right: 10px" (click)="onCloseRequested()">
							Fermer
						</button>
						<button type="button" class="btn btn-primary" style="margin-right: 6px" (click)="onSaveRequested()" 
							title = "Sauvegarder" [disabled]="waitingForServer">
							Sauvegarder
						</button>
					</div>
				</div>
			</div>
		</form>
	</pannel>
</bootstrap-popup>